const priority = [
    {
        id: 1,
        name: "High",
    },
    {
        id: 2,
        name: "Medium",
    },
    {
        id: 3,
        name: "Low",
    },
];

const classification = [
    {
        id: 1,
        name: "Question",
    },
    {
        id: 2,
        name: "Problem",
    },
    {
        id: 3,
        name: "Feature",
    },
    {
        id: 4,
        name: "Others",
    },
];

export { priority, classification };
